export const CHECKOUT_URL =
  'https://checkout.ebookbtnlines.shop/cart/45729266073647:1'

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/mUwVLk9YXZmzKTQZVvznUa/IMG_9466.png'

export const FOCUS_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/2161a2c6-139a-4a7d-9ff7-a1c1e7a20518.jpg'

export type Problem = {
  icon: 'brain' | 'alert' | 'target' | 'activity' | 'refresh'
  title: string
  text: string
}

export const problems: Problem[] = [
  {
    icon: 'brain',
    title: 'Tu cabeza te juega en contra',
    text: 'Entrenás muy bien durante la semana, pero cuando empieza el partido aparecen los nervios, pensás demasiado y terminás jugando muy por debajo de tu verdadero nivel.',
  },
  {
    icon: 'alert',
    title: 'Los nervios aparecen antes de jugar',
    text: 'Horas antes del entrenamiento o del partido empezás a imaginar errores, sentís ansiedad y llegás a la cancha con más tensión de la que te gustaría.',
  },
  {
    icon: 'target',
    title: 'Un solo error te saca del partido',
    text: 'Perdés una bocha, errás un pase o una definición y seguís pensando en esa jugada durante varios minutos. Mientras tanto, seguís equivocándote.',
  },
  {
    icon: 'activity',
    title: 'Jugás en piloto automático',
    text: 'Tu mente está pensando en el resultado, el entrenador, los errores o el rival. Te cuesta estar presente y tomar buenas decisiones durante el juego.',
  },
  {
    icon: 'refresh',
    title: 'Entrenás más, pero seguís sintiendo lo mismo',
    text: 'Seguís haciendo más ejercicios físicos esperando rendir mejor, cuando muchas veces lo que falta entrenar no es el cuerpo... sino la mente.',
  },
]

export type Benefit = {
  icon: 'focus' | 'wind' | 'rotate' | 'shield' | 'trending'
  title: string
  text: string
}

export const benefits: Benefit[] = [
  {
    icon: 'focus',
    title: 'Más concentración',
    text: 'Aprendé a mantener el foco durante todo el entrenamiento o partido sin que los pensamientos negativos interfieran en tu rendimiento.',
  },
  {
    icon: 'wind',
    title: 'Menos ansiedad',
    text: 'Llegá a la cancha con mayor tranquilidad gracias a protocolos específicos de respiración y mindfulness aplicados al hockey.',
  },
  {
    icon: 'rotate',
    title: 'Recuperarte rápido de los errores',
    text: 'Aprendé a dejar atrás una mala jugada y volver al presente en pocos segundos para que un error no arruine todo tu partido.',
  },
  {
    icon: 'shield',
    title: 'Más confianza',
    text: 'Competí con seguridad, disfrutando mucho más del juego y confiando en el trabajo que hiciste durante los entrenamientos.',
  },
  {
    icon: 'trending',
    title: 'Mejor rendimiento',
    text: 'Cuando entrenás tu mente, aprovechás mucho mejor toda la preparación física y técnica que ya venís haciendo.',
  },
]

export type Tomo = {
  number: string
  title: string
  items: string[]
}

export const tomos: Tomo[] = [
  {
    number: 'TOMO 1',
    title: 'Bases del mindfulness para jugadores de hockey',
    items: [
      'Cómo funciona la mente bajo presión.',
      'Atención plena aplicada al hockey.',
      'El piloto automático.',
      'El diálogo interno.',
      'Respiración consciente.',
      'Crear el hábito del entrenamiento mental.',
    ],
  },
  {
    number: 'TOMO 2',
    title: 'Respiración aplicada al hockey',
    items: [
      'Respiración diafragmática.',
      'Respiración para bajar la ansiedad.',
      'Respiración antes del entrenamiento.',
      'Respiración pre partido.',
      'Respiración durante pausas.',
      'Recuperación después del esfuerzo.',
    ],
  },
  {
    number: 'TOMO 3',
    title: 'Conciencia corporal y presencia',
    items: [
      'Escaneo corporal.',
      'Detectar tensión innecesaria.',
      'Relajar el cuerpo antes de competir.',
      'Atención plena durante el movimiento.',
      'Volver al presente.',
      'Conciencia corporal aplicada al hockey.',
    ],
  },
  {
    number: 'TOMO 4',
    title: 'Manejo del estrés competitivo',
    items: [
      'Ansiedad antes de jugar.',
      'Presión competitiva.',
      'Recuperarte después del error.',
      'Manejo de la frustración.',
      'Confianza deportiva.',
      'Mantener la calma bajo presión.',
    ],
  },
  {
    number: 'TOMO 5',
    title: 'Concentración durante el juego',
    items: [
      'Mantener el foco.',
      'Evitar distracciones.',
      'Técnicas de anclaje.',
      'Flow deportivo.',
      'Una jugada a la vez.',
      'Tomar mejores decisiones.',
    ],
  },
  {
    number: 'TOMO 6',
    title: 'Programa completo de entrenamiento mental',
    items: [
      'Antes del entrenamiento.',
      'Antes del partido.',
      'Durante el partido.',
      'Entre tiempos.',
      'Después del partido.',
      'Programa completo de entrenamiento mental de 90 días.',
    ],
  },
]

export const withoutItems: string[] = [
  'Llegás al partido con ansiedad y exceso de tensión.',
  'Un error te persigue durante varios minutos.',
  'Pensás demasiado antes de actuar.',
  'La presión del partido afecta tu rendimiento.',
  'Dependés de tener "un buen día" para jugar bien.',
  'Te frustrás fácilmente cuando las cosas no salen.',
  'Terminás los partidos pensando solo en tus errores.',
  'Entrenás tu cuerpo, pero nunca entrenás tu mente.',
]

export const withItems: string[] = [
  'Llegás a la cancha con una rutina mental que te ayuda a mantener la calma.',
  'Aprendés a recuperarte rápidamente después de una mala jugada.',
  'Tomás decisiones con mayor claridad y confianza.',
  'Competís con tranquilidad incluso bajo presión.',
  'Tenés herramientas para controlar los nervios antes y durante el partido.',
  'Disfrutás mucho más cada entrenamiento y cada competencia.',
  'Terminás cada partido sabiendo qué mejorar sin castigarte mentalmente.',
  'Entrenás tu mente con el mismo compromiso que entrenás tu técnica y tu físico.',
]

export type Testimonial = {
  name: string
  age: string
  city: string
  quote: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'Agustín',
    age: '22 años',
    city: 'Buenos Aires',
    quote:
      'Pensaba que me faltaba confianza. Descubrí que nunca había entrenado mi cabeza.',
  },
  {
    name: 'Camila',
    age: '19 años',
    city: 'Córdoba',
    quote:
      'Llegaba muy nerviosa a los partidos. Hoy entro mucho más tranquila y enfocada.',
  },
  {
    name: 'Joaquín',
    age: '27 años',
    city: 'Rosario',
    quote:
      'Aprendí a recuperarme después de un error y dejé de salir mentalmente del partido.',
  },
  {
    name: 'Martina',
    age: '24 años',
    city: 'Mendoza',
    quote:
      'Los ejercicios de respiración cambiaron completamente mi forma de competir.',
  },
  {
    name: 'Candela',
    age: '31 años',
    city: 'Mar del Plata',
    quote:
      'Ahora disfruto mucho más jugar porque ya no estoy peleando con mi cabeza todo el tiempo.',
  },
]

export type Bono = {
  title: string
  image: string
}

export const bonos: Bono[] = [
  {
    title: '50 ejercicios de mindfulness para jugadores de hockey',
    image:
      'https://cdn.magicpatterns.com/uploads/6ptsXV94Mnw8XjkEQs24BV/IMG_9486.jpg',
  },
  {
    title:
      'Rutinas de respiración para antes, durante y después de entrenamientos y partidos',
    image:
      'https://cdn.magicpatterns.com/uploads/a5Wvz8MT3919HVWaF5wviP/IMG_9485.jpg',
  },
  {
    title: 'Diario de entrenamiento mental de 90 días',
    image:
      'https://cdn.magicpatterns.com/uploads/nq2B8i9DchjHnQGCqBUary/IMG_9484.jpg',
  },
  {
    title:
      'Meditaciones guiadas para concentración, confianza y manejo del estrés',
    image:
      'https://cdn.magicpatterns.com/uploads/mWr47tVewFLse1JNxsn9mn/IMG_9483.jpg',
  },
  {
    title:
      'Protocolos mentales para recuperarte después de errores y volver al foco rápidamente',
    image:
      'https://cdn.magicpatterns.com/uploads/vidcfyeeAnY8P1cBoC4u2D/IMG_9482.jpg',
  },
]
